import React from 'react';
import TileContentContext from './TileContentContext';

export default function useTileContent() {
  return React.useContext(TileContentContext);
}
